/* @flow strict */

import * as React from 'react';
import Modal from '/client/src/components/Modal';
import SimpleInput from '/client/src/components/forms/simpleInput';
import _ from 'lodash';
import { emailRegexp } from '/client/src/constants';

type PropsType = {
  title: string,
  inputNameValue: string,
  handleChangeInputName: () => void,
  inputEmailValue?: string,
  handleChangeInputEmail?: () => void,
  handleSubmit: () => void,
  handleClose: () => void,
  isOpen: boolean,
  isPending: boolean,
  isCreate?: boolean
};

const SponsorsPageModal = ({
  title,
  inputNameValue,
  handleChangeInputName,
  inputEmailValue,
  handleChangeInputEmail,
  handleSubmit,
  handleClose,
  isOpen,
  isPending,
  isCreate
}: PropsType): React.Element<'div'> => {
  const [isChanged, setChanged] = React.useState(false);
  const [isChangedEmail, setChangedEmail] = React.useState(false);
  const [isMach, setMach] = React.useState(false);
  const [isMachEmail, setMachEmail] = React.useState(false);
  const dynamicId = title.replace(/\s+/g, '');

  return (
    <Modal
      overflow='visible'
      opened={isOpen}
      onClose={handleClose}
      altView
      isScrollable
    >
      <div className="modal-dialog customModal modal-table-filter EventPageSponsorModal" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title">
              <span>{title}</span>
            </h4>
          </div>
          <div className="modal-body">
            <SimpleInput
              name={dynamicId}
              id={dynamicId}
              placeholder='Sponsor Name'
              type='text'
              value={inputNameValue}
              onChange={(e: any) => {
                setChanged(true);
                setMach(_.size(e.target.value) > 0);
                handleChangeInputName(e.target.value);
              }}
              validator={isChanged && !isMach ? {
                text: <i className='glyphicon glyphicon-warning-sign' />
              } : false}
            />
          </div>
          <div className="modal-footer">
            <button className="btn btn-gray" onClick={handleClose}>Cancel</button>
            {isCreate ?
              <button
                className={`btn btn-pink actionBtn
                ${!isPending && isMach && isChanged ? '' : 'is-disabled'}`
                }
                onClick={handleSubmit}
              >Save</button>
              :
              <button
                className={`btn btn-pink actionBtn
                ${!isPending && isMach && isChanged ? '' : 'is-disabled'}`
                }
                onClick={handleSubmit}
              >Edit</button>
            }
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default SponsorsPageModal;
